import { render, staticRenderFns } from "./leyuAuth.vue?vue&type=template&id=cfd54cb4&"
import script from "./leyuAuth.vue?vue&type=script&lang=js&"
export * from "./leyuAuth.vue?vue&type=script&lang=js&"
import style0 from "./leyuAuth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports